import { useMantineTheme } from "@mantine/core";
import type { ComponentProps, ReactNode } from "react";
import { ButtonCheckboxV1 } from "./ButtonCheckboxV1";
import { ButtonCheckboxV2 } from "./ButtonCheckboxV2";

export type ButtonCheckboxProps = ComponentProps<typeof ButtonCheckboxV1> & {
  // v2 only: replaces the dot shown when the button is active
  leftSection?: ReactNode;
};

export const ButtonCheckbox = ({
  leftSection,
  ...props
}: ButtonCheckboxProps) => {
  const theme = useMantineTheme();

  return theme.other.version === "v2" ? (
    <ButtonCheckboxV2 {...props} leftSection={leftSection} />
  ) : (
    <ButtonCheckboxV1 {...props} />
  );
};
